import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Switch } from "antd";
var BooleanWidget = /*#__PURE__*/function (_PureComponent) {
  function BooleanWidget() {
    var _this;
    _classCallCheck(this, BooleanWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BooleanWidget, [].concat(args));
    _this.handleChange = function (val) {
      _this.props.setValue(val);
    };
    return _this;
  }
  _inherits(BooleanWidget, _PureComponent);
  return _createClass(BooleanWidget, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        customProps = _this$props.customProps,
        value = _this$props.value,
        labelYes = _this$props.labelYes,
        labelNo = _this$props.labelNo,
        readonly = _this$props.readonly,
        config = _this$props.config;
      var renderSize = config.settings.renderSize;
      return /*#__PURE__*/React.createElement(Switch, _extends({
        checkedChildren: labelYes || null,
        unCheckedChildren: labelNo || null,
        checked: value || null,
        onChange: this.handleChange,
        disabled: readonly,
        size: renderSize
      }, customProps));
    }
  }]);
}(PureComponent);
BooleanWidget.propTypes = {
  setValue: PropTypes.func.isRequired,
  value: PropTypes.bool,
  config: PropTypes.object.isRequired,
  field: PropTypes.any,
  customProps: PropTypes.object,
  readonly: PropTypes.bool,
  // from fieldSettings:
  labelYes: PropTypes.string,
  labelNo: PropTypes.string
};
BooleanWidget.defaultProps = {
  labelYes: null,
  labelNo: null
};
export { BooleanWidget as default };